
import { useContext, useRef, useState } from 'react'
import Home from '../../client_pages/home_page/Home'
import Navbar from '../../navbar/Navbar';
import Branches from '../../client_pages/branches_page/Branches';
import Jobs from '../../client_pages/jobs_page/Jobs';
import HelpDesk from '../../client_pages/helpdesk_page/HelpDesk';
import Categories from '../../client_pages/categories_page/Categories';
import Footer from '../../Footer';
import ProductPage from '../../client_pages/product_page/ProductPage';
import AboutPage from '../../client_pages/about_page/AboutPage';
import { AppContext } from '../../../contextApi/ContextApi';
import WebsiteNotActive from '../../WebsiteNotActive';

export default function DisplayMyWebsite({website, navbarArr, isActive}) {
  const {accent_color, secondary_color} = useContext(AppContext);
  const [display, setDisplay] = useState(0);
  const navRef = useRef(null);

  // Dashboard website overlook remote controller:
  const changeDisplay=()=>{
    switch(display){
      case "/home": return <Home website={website} isDashboard={true} setDisplay={setDisplay}/>
      case "/products": return <Categories website={website} isDashboard={true} setDisplay={setDisplay}/>
      case "/our_branches": return <Branches website={website} isDashboard={true}/>
      case "/our_jobs": return <Jobs website={website} isDashboard={true}/>
      case "/helpdesk": return <HelpDesk website={website} isDashboard={true}/>
      case "/about": return <AboutPage website={website} isDashboard={true}/>
      case "/productPage": return <ProductPage website={website} isDashboard={true}/>
      default: return <Home website={website} isDashboard={true} setDisplay={setDisplay}/>
    }
  }
  return (
    isActive ? 
      <div className='displayMyWebsite' style={{minHeight:"100vh", backgroundColor:secondary_color, color:accent_color}}>
        <Navbar isDashboard={true} setDisplay={setDisplay} navRef={navRef} navbarArr={navbarArr}/>
        {changeDisplay()}
        <Footer isDashboard={true} setDisplay={setDisplay} navRef={navRef} navbarArr={navbarArr}/>
      </div> : 
      <div className='displayMyWebsite' style={{minHeight:"100vh", backgroundColor:secondary_color, color:accent_color}}>
        <WebsiteNotActive isDashboard={true}/>
      </div>
    
  )
}
